import React, { useEffect, useState } from 'react';
import { db } from '../firebase'; // إعدادات Firebase
import { collection, getDocs, query, where } from 'firebase/firestore';

const PublicPathsPage = () => {
  const [paths, setPaths] = useState([]);
  const [loading, setLoading] = useState(true);
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [search, setSearch] = useState('');
  const [filteredPaths, setFilteredPaths] = useState([]);

  useEffect(() => {
    const fetchPaths = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'publicPaths'));
        const pathsList = [];
        querySnapshot.forEach((doc) => {
          pathsList.push({ id: doc.id, ...doc.data() });
        });
        setPaths(pathsList);
        setFilteredPaths(pathsList); // عرض جميع المسارات في البداية
        setLoading(false);
      } catch (err) {
        console.error('خطأ في جلب المسارات:', err);
        setLoading(false);
      }
    };

    fetchPaths();
  }, []);

  const handleSearch = () => {
    let filtered = paths;

    if (search) {
      filtered = filtered.filter((path) =>
        path.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (country) {
      filtered = filtered.filter((path) => path.country === country);
    }

    if (city) {
      filtered = filtered.filter((path) => path.city === city);
    }

    if (minPrice) {
      filtered = filtered.filter((path) => path.price >= parseFloat(minPrice));
    }

    if (maxPrice) {
      filtered = filtered.filter((path) => path.price <= parseFloat(maxPrice));
    }

    setFilteredPaths(filtered);
  };

  if (loading) {
    return <div className="text-center mt-20 text-xl">جاري تحميل المسارات...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* نموذج الفلترة */}
        <div className="bg-white p-6 rounded-lg shadow-xl mb-8">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">استكشاف الحمامات العامة</h2>
          <div className="flex flex-wrap justify-between gap-4">
            {/* البحث */}
            <div className="w-full sm:w-1/4">
              <input
                type="text"
                placeholder="البحث بالاسم..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* البلد */}
            <div className="w-full sm:w-1/4">
              <select
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                <option value="">البلد</option>
                {/* إضافة خيارات البلدان إذا لزم الأمر */}
                <option value="USA">الولايات المتحدة</option>
                <option value="Egypt">مصر</option>
                <option value="France">فرنسا</option>
              </select>
            </div>

            {/* المدينة */}
            <div className="w-full sm:w-1/4">
              <select
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                <option value="">المدينة</option>
                {/* إضافة خيارات المدن إذا لزم الأمر */}
                <option value="Cairo">القاهرة</option>
                <option value="Paris">باريس</option>
                <option value="New York">نيويورك</option>
              </select>
            </div>

            {/* نطاق السعر */}
            <div className="w-full sm:w-1/4">
              <div className="flex gap-4">
                <input
                  type="number"
                  placeholder="أقل سعر"
                  value={minPrice}
                  onChange={(e) => setMinPrice(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                <input
                  type="number"
                  placeholder="أعلى سعر"
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>
            </div>

            {/* زر البحث */}
            <div className="w-full sm:w-1/4">
              <button
                onClick={handleSearch}
                className="w-full p-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                بحث
              </button>
            </div>
          </div>
        </div>

        {/* قائمة المسارات */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredPaths.map((path) => (
            <div key={path.id} className="bg-white p-6 rounded-lg shadow-lg">
              {/* صورة المسار */}
              {path.image ? (
                <img
                  src={path.Image}
                  alt={path.Name}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
              ) : (
                <div className="w-full h-48 bg-gray-300 rounded-lg mb-4 flex items-center justify-center text-gray-600">
                  لا توجد صورة
                </div>
              )}

              {/* تفاصيل المسار */}
              <h2 className="text-xl font-semibold text-gray-800">{path.Name}</h2>
              <p className="text-gray-600 mt-2">{path.Description}</p>
              <p className="text-gray-700 font-semibold mt-4">السعر: دج{path.Price}</p>
              <p className="text-gray-500">{path.City}, {path.Country}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PublicPathsPage;
